export const solutionsRouts = {
  name: "SOLUTIONS",
  to: "/solutions",
  children: [
    { to: "https://www.sikkasoft.com/Marketplace",  name: "Marketplace"},
    { to: "https://www.sikkasoft.com/online-consult",  name: "Online Consult" },
    { to: "https://www.sikkasoft.com/SikkaPay/",  name: "Integrated Payments" }
  ]
};

export const insightsRouts = {
    name: "INSIGHTS",
    to: "/insights",
    children: [
      { to: "https://www.sikkasoft.com/sikka-insights",  name: "Sikka Insights"},
      { to: "https://www.sikkasoft.com/covid-19-rebound/",  name: "Covid-19 Rebound" },
      { to: "https://www.sikkasoft.com/V3/insights/insurance.html",  name: "Life Insurance" }
    ]
  };

  export const developersRouts = {
    name: "DEVELOPERS",
    to: "/developers",
    children: [
      { to: "https://www.sikkasoft.com/V3/developers/oneapi.html",  name: "One API"},
      { to: "https://api.sikkasoft.com/portal/Home.htm",  name: "API Portal" },
      { to: "https://sikkasoftware.freshdesk.com/support/solutions/folders/33000202063",  name: "FAQ" }
    ]
  };

  export const companyRouts = {
    name: "COMPANY",
    to: "/company",
    children: [
      { to: "https://www.sikkasoft.com/V3/company/aboutus.html",  name: "About Us"},
      { to: "https://www.sikkasoft.com/V3/company/careers.html",  name: "Careers" },
      { to: "https://sikkablog.com/",  name: "Blog" },
      { to: "https://en.sikkasoft.com/request-a-demo/",  name: "Request Demo" },
      { to: "https://sikkasoftware.freshdesk.com/support/home",  name: "Support" }
    ]
  };
export default [
    solutionsRouts,
    insightsRouts,
    developersRouts,
    companyRouts
];
